import type { PaletteAlias } from '@cbhq/cds-web'
import { Button as CDSButton } from '@cbhq/cds-web/buttons/Button'
import type { ButtonProps } from '@cbhq/cds-web/buttons/Button'
import { Pressable as CDSPressable } from '@cbhq/cds-web/system/Pressable'
import type { PressableInternalProps } from '@cbhq/cds-web/system/Pressable'

import { Div } from './Div'
import { useAnalyticsContext } from '../providers/AnalyticsProvider'

type CDXButtonProps = Omit<ButtonProps, 'to'> & { 'data-qa'?: string }

export function Button({ 'data-qa': dataQa, ...props }: CDXButtonProps) {
  const { analyticsPrefix } = useAnalyticsContext()

  const finalDataQa = `${analyticsPrefix}${
    dataQa && analyticsPrefix ? '-' : ''
  }${dataQa}`

  return (
    <Div>
      <CDSButton data-qa={finalDataQa} {...props} />
    </Div>
  )
}

type CDXPressableProps = Omit<PressableInternalProps, 'to' | 'background'> & {
  background?: PaletteAlias
  'data-qa'?: string
}

export function Pressable({ 'data-qa': dataQa, ...props }: CDXPressableProps) {
  const { analyticsPrefix } = useAnalyticsContext()

  const finalDataQa = `${analyticsPrefix}${
    dataQa && analyticsPrefix ? '-' : ''
  }${dataQa}`

  return (
    <CDSPressable data-qa={finalDataQa} background="transparent" {...props} />
  )
}
